// @flow

import React from "react";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import { SectionComponent } from "@components";
import { compose } from "redux";
import type { EditInteractionModal as EditInteractionModalType } from "@modules/shared/reducer/employee-absences/types";
import actionCreators from "@modules/shared/actionCreator";
import { getEditInteractionModal } from "@modules/shared/selectors/employee-absences";
import type { State } from "@store/reducers";
import { EditInteractionModal, AbsenceDetailsInteractionsTable } from "@modules/shared/components";

type OwnProps = $Exact<{
  id: string,
  title: ?string,
  clientId: ?number,
  employeeId: number,
  absenceId: number,
  allowEdit: ?boolean,
  hideEditBtn: ?boolean,
}>;

type PropsFromState = $Exact<{
  editInteractionModal: EditInteractionModalType,
}>;

type PropsFromDispatch = $Exact<{
  toggleEditInteractionModal: typeof actionCreators.ToggleEditEmployeeInteractionModal,
  updateInteraction: typeof actionCreators.UpdateEmployeeInteraction,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

type ComponentState = $Exact<{
  isSectionOpen: boolean,
}>;

export class AbsenceDetailsInteractions extends React.Component<Props, ComponentState> {
  state = {
    isSectionOpen: true,
  };

  closeEditInteractionModal = () => {
    this.props.toggleEditInteractionModal({
      visible: false,
    });
  };

  handleUpdateInteraction = (formData: Object) => {
    this.props.updateInteraction({
      clientId: this.props.clientId,
      employeeId: this.props.employeeId,
      absenceId: this.props.absenceId,
      formData,
    });
    this.closeEditInteractionModal();
  };

  toggleSection = () => {
    this.setState({
      isSectionOpen: !this.state.isSectionOpen,
    });
  };

  render() {
    return (
      <SectionComponent
        id={this.props.id}
        title={<h5>{this.props.title ? this.props.title : this.props.t("INTERACTIONS")}</h5>}
        wrapperClassName="flex-column"
        t={this.props.t}
        onTitleClick={this.toggleSection}
        isOpen={this.state.isSectionOpen}
        className="gs-container"
      >
        <AbsenceDetailsInteractionsTable
          clientId={this.props.clientId}
          employeeId={this.props.employeeId}
          absenceId={this.props.absenceId}
          allowEdit={this.props.allowEdit}
          hideEditBtn={this.props.hideEditBtn}
        />
        {this.props.editInteractionModal.visible && (
          <EditInteractionModal
            interaction={this.props.editInteractionModal.data}
            onDismissHandler={this.closeEditInteractionModal}
            onSubmit={this.handleUpdateInteraction}
          />
        )}
      </SectionComponent>
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => ({
  editInteractionModal: getEditInteractionModal(state),
});

const mapDispatchToProps: PropsFromDispatch = {
  toggleEditInteractionModal: actionCreators.ToggleEditEmployeeInteractionModal,
  updateInteraction: actionCreators.UpdateEmployeeInteraction,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(AbsenceDetailsInteractions);
